'use strict';

var angular = require('angular');

var DownloadStatusService = /*@ngInject*/ function (Session, $cookies) {
  var _self = this;
  _self.cookieName = 'assetDownloadStatus';

  _self.readCookie = function (id) {
    var _userName = Session.get('userName'),
      _name = [_userName, id].join('-'),
      _downloadList = $cookies.getObject(_self.cookieName),
      _status = false;
    if (_downloadList) {
      _status = _downloadList[_name];
    }
    return _status;
  };

  _self.writeCookie = function (jobList, flag) {
    var _userName = Session.get('userName'),
      _name,
      _downloadList = $cookies.getObject(_self.cookieName) || {};

    if (!angular.isArray(jobList)) {
      jobList = [jobList];
    }

    if (flag === undefined) {
      flag = true;
    }

    for (var i = 0; i < jobList.length; i++) {
      _name = [_userName, jobList[i]].join('-');

      _downloadList[_name] = flag;
    }

    $cookies.putObject(_self.cookieName, _downloadList);
  };

  _self.removeCookie = function () {
    $cookies.remove(_self.cookieName);
  };
};

module.exports = DownloadStatusService;
